import commonservice from "@apis/commonservice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { sortByOrder } from "@utils/array";

import { ContactQrcode, GlobalNotify, Option, RegionOption, UserTelephone } from "./types";

const GLOBAL_CONFIG_KEY = [
  { reqKey: "global.language", stateKey: "languageOptions" },
  { reqKey: "global.country", stateKey: "regionOptions" },
  { reqKey: "user.telephone", stateKey: "userTelephone" },
  { reqKey: "video.language", stateKey: "videoLanguage" },
  { reqKey: "target.market", stateKey: "sellingCountry" },
];

type ConfigState = {
  ready: boolean;
  // 全局
  languageOptions: Option[];
  regionOptions: RegionOption[];
  contactQrcode: ContactQrcode[];
  userTelephone: UserTelephone[];
  videoLanguage: Option[];
  sellingCountry: (Option & { name?: string })[];
};

const initialState: ConfigState = {
  ready: false,
  // 全局
  languageOptions: [],
  regionOptions: [],
  contactQrcode: [],
  userTelephone: [],
  videoLanguage: [],
  sellingCountry: [],
};

export const fetchGlobalConfig = createAsyncThunk("config/fetchGlobalConfig", async () => {
  const reqData = GLOBAL_CONFIG_KEY.map(({ reqKey }) => reqKey);
  const data = await commonservice.fetchConfigs<{
    "global.language": Option[];
    "global.country": RegionOption[];
    "contact.qrcode": ContactQrcode[];
    "user.telephone": UserTelephone[];
    "global.notify": GlobalNotify[];
    "video.language": Option[];
    "target.market": (Option & { name?: string })[];
  }>({ reqData });
  return data;
});

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchGlobalConfig.fulfilled, (state, action) => {
        const data = action.payload;
        if (data) {
          const keys = Object.keys(data);
          for (let key of keys) {
            switch (key) {
              case "global.language": {
                state.languageOptions = data[key];
                break;
              }
              case "global.country": {
                let regionOptions = sortByOrder<RegionOption>(data[key]);
                state.regionOptions = [...regionOptions];
                break;
              }
              case "user.telephone": {
                state.userTelephone = sortByOrder<UserTelephone>(data[key]);
                break;
              }
              case "contact.qrcode": {
                state.contactQrcode = data[key];
                break;
              }
              case "video.language": {
                state.videoLanguage = data[key];
                break;
              }
              case "target.market": {
                state.sellingCountry = data[key];
                break;
              }
            }
          }
        }
        state.ready = true;
      })
      .addCase(fetchGlobalConfig.rejected, (state, _action) => {
        state.ready = true;
      });
  },
});

const configReducer = configSlice.reducer;
export default configReducer;
